export type AddRecordEmptyStateActionType = "createService" | "createMaster" | "goToServiceList" | "goToMasterList";

export type AddRecordEmptyStateConfig = {
    messageKey: string;
    actionLabelKey?: string;
    actionType?: AddRecordEmptyStateActionType;
    actionIconClassName?: string | null;
};

type ServiceEmptyStateFlags = {
    isAnyActiveServices: boolean | null;
    canCreateService: boolean;
    canViewServiceList: boolean;
};

type MasterEmptyStateFlags = {
    shouldRestrictCreateBookingToSelf: boolean;
    hasActiveEmployees: boolean | null;
    canCreateEmployee: boolean;
    canViewEmployeeList: boolean;
};

export const getServiceEmptyStateConfig = ({
    isAnyActiveServices,
    canCreateService,
    canViewServiceList,
}: ServiceEmptyStateFlags): AddRecordEmptyStateConfig | undefined => {
    if (isAnyActiveServices === false) {
        return {
            messageKey: "No available services",
            actionLabelKey: canCreateService ? "Create a service" : undefined,
            actionType: canCreateService ? "createService" : undefined,
        };
    }

    if (isAnyActiveServices === true) {
        return {
            messageKey: "No available services",
            actionLabelKey: canViewServiceList ? "To the service list" : undefined,
            actionType: canViewServiceList ? "goToServiceList" : undefined,
            actionIconClassName: null,
        };
    }

    return undefined;
};

export const getMasterEmptyStateConfig = ({
    shouldRestrictCreateBookingToSelf,
    hasActiveEmployees,
    canCreateEmployee,
    canViewEmployeeList,
}: MasterEmptyStateFlags): AddRecordEmptyStateConfig | undefined => {
    if (shouldRestrictCreateBookingToSelf) {
        return {
            messageKey: "No available masters",
            actionLabelKey: canViewEmployeeList ? "To the master list" : undefined,
            actionType: canViewEmployeeList ? "goToMasterList" : undefined,
            actionIconClassName: null,
        };
    }

    if (hasActiveEmployees === false) {
        return {
            messageKey: "No available masters",
            actionLabelKey: canCreateEmployee ? "Create a master" : undefined,
            actionType: canCreateEmployee ? "createMaster" : undefined,
        };
    }

    if (hasActiveEmployees === true) {
        return {
            messageKey: "No available masters",
            actionLabelKey: canViewEmployeeList ? "To the master list" : undefined,
            actionType: canViewEmployeeList ? "goToMasterList" : undefined,
            actionIconClassName: null,
        };
    }

    return undefined;
};
